package com.swetdot.swetgram.domain

import com.swetdot.swetgram.protocol.dto.PicsoAnalytics
import com.swetdot.swetgram.protocol.dto.PicsoAuthor
import com.swetdot.swetgram.protocol.dto.PicsoFeedPage
import com.swetdot.swetgram.protocol.dto.PicsoLimits
import com.swetdot.swetgram.protocol.dto.PicsoPost
import com.swetdot.swetgram.protocol.dto.PicsoReactionSummary
import com.swetdot.swetgram.protocol.dto.PicsoSaveStatus
import kotlin.jvm.JvmInline
import kotlin.time.Instant

@JvmInline
value class PicsoId(val value: String) {
    override fun toString(): String = value
}

enum class PicsoFeedTab(val wire: String) {
    ALL("all"),
    SAVED("saved");
}

data class PicsoPostItem(
    val id: PicsoId,
    val authorId: String,
    val authorUsername: String,
    val authorDisplayName: String,
    val authorAvatarUrl: String?,
    val mediaId: String,
    val mediaUrl: String,
    val caption: String?,
    val publishedAt: String,
    val expiresAt: String,
    val viewsCount: Int,
    val uniqueViewersCount: Int,
    val reactionsCount: Int,
    val myReaction: String?,
    val isSaved: Boolean,
    val isMine: Boolean,
)

fun PicsoPostItem.isActiveAt(now: Instant): Boolean =
    runCatching { Instant.parse(expiresAt) > now }.getOrDefault(false)

fun PicsoPost.toDomain(): PicsoPostItem = PicsoPostItem(
    id = PicsoId(id),
    authorId = author.id,
    authorUsername = author.username,
    authorDisplayName = author.displayName,
    authorAvatarUrl = author.avatarUrl,
    mediaId = mediaId,
    mediaUrl = mediaUrl,
    caption = caption,
    publishedAt = publishedAt,
    expiresAt = expiresAt,
    viewsCount = viewsCount,
    uniqueViewersCount = uniqueViewersCount,
    reactionsCount = reactionsCount,
    myReaction = myReaction,
    isSaved = isSaved,
    isMine = isMine,
)
